"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eulaVersion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable max-len */
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var OrderedListWrapper_1 = __importDefault(require("atomicComponents/atoms/List/OrderedListWrapper"));
var Main_1 = __importDefault(require("components/Layout/Main"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Banner_1 = __importDefault(require("containers/App/Policies/styles/Banner"));
var Wrapper_1 = __importDefault(require("containersRechargly/Recharges/StripeClientAgreement/Wrapper"));
var EULA_md_1 = __importDefault(require("raw-loader!./EULA.md"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
// Please remember to change this number as you change the EULA content
exports.eulaVersion = 1;
var EULA = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "End User Licence Agreement", description: "Rechargly's End User Licence Agreement" }), (0, jsx_runtime_1.jsx)(Main_1.default, { children: (0, jsx_runtime_1.jsxs)(Wrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(Banner_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "End User Licence Agreement" })) }), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 1 }, { children: ["Version number: ", exports.eulaVersion] })), (0, jsx_runtime_1.jsx)(OrderedListWrapper_1.default, { children: (0, jsx_runtime_1.jsx)(markdown_to_jsx_1.default, { children: EULA_md_1.default }) })] }) })] })); };
exports.default = EULA;
